/* @flow */

import keymirror from 'keymirror';

const DatasetConstants = keymirror({
  DATASET_LOAD: null,
  DATASET_SET_STATUS: null,
});

export { DatasetConstants };
